import { FocusNode } from '@please/lrud'
import { Element } from 'react-scroll'
import styled, { css } from 'styled-components'

import { HeaderElem, Title } from '@/components/SettingsHeader/styles'
import { PageContainer } from '@/containers/Search/styles'

import { ScrollContainer, SettingsContainer } from '../styles'

export const SettingsSubscriptionsWrapper = styled(SettingsContainer)`
  padding-right: 0;
  z-index: 0;
`

export const SubscriptionsContainer = styled.div<{ $centerContent: boolean }>`
  display: flex;
  flex: 1;
  justify-content: ${({ $centerContent }) =>
    $centerContent ? 'center' : 'flex-start'};
  margin-bottom: 16px;
  padding: 4px;
`

export const SubscriptionNode = styled(FocusNode)<{
  $isBought: boolean
}>`
  border-radius: 12px;
  overflow: hidden;
  &.isFocused {
    border: 0 !important;
    box-shadow: 0 0 0 4px
      ${(props) => props.theme.colors.subscription.focusedElem.border};
    ${({ $isBought }) =>
      $isBought
        ? css`
            & button.isFocusedLeaf {
              background-color: ${(props) =>
                props.theme.colors.button.background} !important;
              color: ${(props) => props.theme.colors.button.text} !important;
              border-color: ${(props) =>
                props.theme.colors.button.border} !important;
              img {
                filter: none;
              }
            }
          `
        : css`
            & button.isFocusedLeaf {
              border-color: ${(props) =>
                props.theme.colors.button.primary} !important;
            }
          `}
  }
`
export const SubscriptionCard = styled.div`
  position: relative;
  width: 440px;
  height: 578px;
  padding: 16px 0;
  background: ${(props) => props.theme.colors.subscription.background};
`

export const SubscriptionContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
export const CreditPackageInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  padding: 40px 16px;
  z-index: 1;
`
export const CreditsBadge = styled.div<{
  $isPromotionCredits?: boolean
}>`
  display: flex;
  align-items: center;
  font-size: 20px;
  line-height: 32px;
  font-weight: 500;
  height: 32px;
  padding: 0 10px;
  border-radius: 30px;
  width: auto;
  margin: 0 auto 16px;
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme, $isPromotionCredits }) =>
    $isPromotionCredits ? theme.colors.badgeLiveBg : theme.colors.textDark};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  & img {
    height: 20px;
    width: 20px;
    object-fit: contain;
    margin-left: 6px;
  }
`
export const CreditTitle = styled.div`
  width: 100%;
  font-size: 32px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.text};
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  & span {
    color: #ffc622;
  }

  @supports (-webkit-background-clip: text) or (background-clip: text) {
    & span {
      background: linear-gradient(to bottom, #ff9d00, #fff045);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
  }
`

export const ButtonWrapper = styled.div`
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
  padding: 16px;
  z-index: 1;
`

export const StyledScrollContainer = styled(ScrollContainer)`
  height: 660px;
  display: flex;
  padding-right: 96px;
`

export const StyledElement = styled(Element)`
  padding: 0 16px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`

export const DarkeningContainer = styled.div`
  background-color: ${(props) => props.theme.colors.subscription.inActiveElem};
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 2;
`
export const LoginButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 100px;
`
export const ButtonDescription = styled.p`
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 20px;
  text-align: left;
`

export const ContentUnavailableWrapper = styled.div`
  height: 640px;
  margin-right: 100px;
  margin-bottom: 16px;
`

export const PageContentUnavailableWrapper = styled.div`
  height: 1080px;
  padding: 50px 112px 50px 0;
`
export const SubscriptionsWrapper = styled(PageContainer)`
  z-index: 0;
  ${HeaderElem} {
    margin: 67px 0 30px;
  }

  ${Title} {
    font-size: 60px;
    line-height: 1.1;
    color: ${(props) => props.theme.colors.pageHeader.title};
    margin-bottom: 20px;
  }
  ${LoginButtonWrapper} {
    margin-right: 112px;
  }
  ${StyledScrollContainer} {
    padding-right: 112px;
  }
`
